import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../contexts/ProfileContext';
import UserEditModal from '../components/UserEditModal';
import ThemeToggle from '../components/ThemeToggle';
import './Users.css';

const Users: React.FC = () => {
  const { profiles, loading, refreshProfiles } = useProfile();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState<any>(null);
  const navigate = useNavigate();

  const handleAddClick = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (profile: any) => {
    setEditingUser(profile);
    setIsModalOpen(true);
  };

  return (
    <div className="users-page">
      <header className="page-header">
        <div className="header-left">
          <button onClick={() => navigate('/dashboard')} className="btn-back">← Back</button>
          <h1>👥 Users & Devices</h1>
        </div>
        <div className="header-right">
          <ThemeToggle placement="header" />
          <button onClick={handleAddClick} className="btn-add-entry">+ Add User</button>
        </div>
      </header>

      <div className="users-container">
        {loading ? (
          <div className="loading-state">Loading users...</div>
        ) : profiles.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">👥</div>
            <h2>No Users Yet</h2>
            <p>Add your first user to start tracking bolus doses and glucose readings.</p>
            <button onClick={handleAddClick} className="btn-primary">Add User</button>
          </div>
        ) : (
          <div className="users-grid">
            {profiles.map(profile => (
              <div key={profile.id} className="user-card" onClick={() => handleEditClick(profile)}>
                <div className="user-card-header">
                  <h3>{profile.name}</h3>
                  <span className="user-type-badge">{profile.user_type || 'User'}</span>
                </div>
                <div className="user-card-body">
                  <p><strong>Target BG:</strong> {profile.target_blood_glucose || 100} mg/dL</p>
                  <div className="device-status">
                    {profile.has_cgm_enabled ? (
                      <span className="status-badge success">📡 Dexcom Polling Active</span>
                    ) : (
                      <span className="status-badge inactive">❌ No CGM Configured</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <UserEditModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={refreshProfiles}
        initialUser={editingUser}
      />
    </div>
  );
};

export default Users;
